import React, { useState, useEffect } from "react";
import { useNavigate, useParams, Navigate, Link, useLocation } from 'react-router-dom';
import { getAuth, deleteUser } from "firebase/auth";
import { useAuthContext } from '../../AuthContext';
import IfProxy from '../../IfProxy';
import IfProxyTu from '../../IfProxyTu';


import HeadFooter from '../HeadFooter';

import TutorialProgressGraph from '../../common/graphs/TutorialProgressGraph';

// ReactGA Analytics
import ReactGA from "react-ga4";

// Material UI
import { makeStyles } from '@mui/styles';
import Checkbox from '@mui/material/Checkbox';

// スピナーアニメーション
import { Dna } from 'react-loader-spinner'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Typography from '@mui/material/Typography';


/**
 * ユーザ参照
 * @param  
 * @returns 
 */
const GuidTo4 = (props) => {
  const [loading, setLoading] = useState(true);
  // クリックされたイベントの情報をモーダルに渡す
  const [clickedEventData, setClickedEventData] = useState("");
  const [modalShow, setModalShow] = useState(false);


  // チェックボックス
  const [userData, setUserData] = useState({});



  const auth = getAuth();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const classes = useStyles();
  const params = useParams();
  const location = useLocation();


  const ifProxy = new IfProxy();
  const ifProxyTu = new IfProxyTu();


  let first = true;
  useEffect((props) => {
    if (first) {
      setLoading(true)
      // ReactGA Analytics ---
      ReactGA.initialize("G-2ZCXE08H2S");
      ReactGA.send({
        hitType: "pageview",
        // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
        page: location.pathname + location.search,
      });
      // ------
      loadData();
    }

    first = false;
    return () => {
    }

  }, []);

  const loadData = async () => {
    const userDataByQuery = await ifProxyTu.getUserData(user.uid);
    setUserData(userDataByQuery);

    setLoading(false)
  }



  // ログイン中かどうかを確認し、ログインユーザを保持していなかったらログイン画面へ
  if (!user) {

    if (loading) {
      return (
        <HeadFooter>
          <Box className={classes.contentWrapper}>
            <Box className={classes.mainBox}>
              <p>読み込み中...</p>
              <Dna
                visible={true}
                height="80"
                width="80"
                ariaLabel="dna-loading"
                wrapperStyle={{}}
                wrapperClass="dna-wrapper"
              />
            </Box>
          </Box>
        </HeadFooter>
      )
    } else {
      //ログインしていないユーザ向けのプロフィール画面
      return (
        <></>
      )
    }
  } else if (loading) {
    return (
      <HeadFooter>
        <Box className={classes.contentWrapper}>
          <Box className={classes.mainBox}>
            <p>読み込み中...</p>
            <Dna
              visible={true}
              height="80"
              width="80"
              ariaLabel="dna-loading"
              wrapperStyle={{}}
              wrapperClass="dna-wrapper"
            />
          </Box>
        </Box>
      </HeadFooter>
    )
  } else {

    const twitterShareUrl = "http://twitter.com/share?url=" + window.location.origin + '/User/' + params.id + "&text=ワンドロテーマを募集中&hashtags=ワンフロ"

    // Boxレイアウトのレスポンシブ対応
    // https://mui.com/components/grid/#responsive-values
    return (
      < HeadFooter >

        <Box className={classes.contentWrapper}>
          <Grid container className={classes.modalGrid} >
            {/** 0段目 ===================================================================== */}

            <Grid item xs={12}>
              <Typography variant="h5">
                １）「興味がある！」ボタンはどう使うか
              </Typography>
              <Typography variant="body1" paragraph>
                推しの作家さんの獲得、未来のファンの獲得に活かせます<br></br>
                フォロー（ブックマーク）とは違い、リンクが保存されたり、回数がカウントされたりはしません。通知が飛ぶだけです
              </Typography>
              <Typography variant="body1" paragraph>
                このボタンを押すと起こることはシンプルです。気になるユーザのプロフィールで「興味がある！」ボタンを押すと、誰から押されたのか、が相手に通知されます
              </Typography>
              <Typography variant="body1" paragraph>
                もしあなたが通知を受けたら、誰が自分のプロフィールに興味を持ってくれたのか、相手を見に行くことができます
              </Typography>
              <Typography variant="body1" paragraph>
                作家さんに自分を意識してもらい、フォロ-関係に繋げたり
              </Typography>
              <Typography variant="h6">
                逆に<b>この方法は、趣味が似ているファンへ、作家さんの方から認知を得るきっかけにもなります
                </b>
              </Typography>


            </Grid>


            <Grid item xs={12}>
              <Typography variant="body1" paragraph>
                「興味がある！」ボタンは次のように利用が可能です
              </Typography>

              <ul>
                <li>作家さん(または自分の作品がヒットしそうなユーザ)のプロフィール画面に行きます</li>
                <li>プロフィール画面の「興味がある」ボタンを押します</li>
                <li>もしかすると、通知をきっかけにあなたのプロフィールを見に来てくれるかもしれません</li>
              </ul>
              <img src={`${process.env.PUBLIC_URL}/tu4.png`}
                style={{
                  width: '100%',
                  maxWidth: "1000px",
                  margin: "0 auto",
                  opacity: 0.8,
                  display: "block",
                }} />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5">
                2) つながりのきっかけに使ってください
              </Typography>
              <Typography variant="body1" paragraph>
                性癖（趣向）が近いなど、作家さん同士のつながりのきっかけに活かして欲しいです
              </Typography>
              <Typography variant="body1" paragraph>
                もしくは、<b>いいリクエストをよく出すユーザに、興味を持ってもらいたいとき</b>、<br></br>
                訪問返ししてもらえるかもしれないため、「興味がある！」を伝えます
              </Typography>
              <Typography variant="h6" paragraph>
                このサイトでは、作家さんだけではなく、<br></br>
                <b>いいリクエストが多いユーザも注目すべきクリエイターと捉えるべきです</b>
              </Typography>
              <Typography variant="body1" paragraph>
                作家さんにとっても、いいリクエスターと出会うことは、自分の知らなかった可能性を、ファンの目で引き出してくれる、良い出会いになる可能性があります<br></br>
                <b>いいリクエストがよく出るユーザも、お題機能（「クリエイター」になる。にて解説）などで、注目してください</b>
              </Typography>

            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" fullWidth={true} onClick={() => {
                ifProxyTu.activateTu_4_firstPoll(userData.id);
                navigate('/tu')

              }}>理解した!<br></br>チュートリアルに戻る</Button>
            </Grid>
          </Grid>

        </Box>

      </HeadFooter >

    );
  }




}
export default GuidTo4;

const useStyles = makeStyles((theme) => ({
  //オーバーレイ
  overlay: {
    zIndex: 10,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },//オーバーレイの中のモーダル
  modalView: {
    zIndex: 10,
    borderRadius: 15,
    width: '50%',
    padding: '1em',
    background: '#fff',
  },
  // 全体レイアウト
  contentWrapper: {
    marginTop: 20,
    flexDirection: 'column',
    alignItems: 'center',
  },
  mainBox: {
    maxWidth: "1000px",
    margin: "0 auto",

  },
  // グリッド箱の書式 
  // モーダルのグリッド全体
  modalGrid: {
    //maxWidth: 1000,
    padding: 0,
    margin: '0 auto'

  },
  taskItem: {
    padding: 20,
    margin: 20,
    border: '2px solid',
    borderColor: '#a6d4fa',
    borderRadius: 20
  },
  taskItemGuide: {
  },

  gridPadding: {
    padding: 5,
    border: '2px solid',
    borderColor: '#a6d4fa',
    backgroundColor: 'linear-gradient(to bottom right,#a6d4fa,#1976d2)',
    borderRadius: '10'

  },
  // グリッド箱の書式 枠線なし
  gridPaddingNoborder: {
    padding: 5,


  },
  // 個別コンテンツ　中央揃えで縦に内容を並べる
  centerBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },// 個別コンテンツ　中央揃えで横に内容を並べる
  centerFlatBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  // 個別コンテンツ　左揃えで縦に内容を並べる
  leftCenterBox: {
    display: 'flex',
    paddingRight: 10,
    flexDirection: 'column',
    alignItems: 'left',
  },
  // 個別コンテンツ　左揃えで縦に内容を並べる
  leftRowBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'left',
  },
  // 個別コンテンツ　横並びに内容を並べる
  leftBox: {
    display: 'flex',
    flexDirection: 'row',
    margin: "0 auto",
  },

  // モーダルダイアログのフォーム　個別アイテム
  modalFormItem: {
    margin: 20,
  },
  //サンプルのグラフエリア
  sampleGraphEria: {
    width: 200
  },

  cardList: {
  },
  card: {
  },
  bottomCard: {
    width: 250
  },
}));



